import React, { useState } from "react";
import { makeStyles } from "@material-ui/core";

import { randomColor } from "../../../utils/colorRandomize";

import TemplateField from "./TemplateField";

const useStyles = makeStyles(() => ({
  wrapper: {
    position: "relative",
    borderLeft: `2px dashed ${randomColor()}`,
    borderRadius: 10,
    marginTop: 5,
    marginBottom: 5,
  },
  shift: {
    marginLeft: 50,
  },
}));

const TemplateNestedField = ({
  onChange,
  onDelete,
  templateIndex,
  setTemplates,
  templates,
  setError,
  setIsChange,
  currentNode,
}) => {
  const [isHideNestedItems, setIsHideNestedItems] = useState(false);
  const classes = useStyles();

  return (
    <div className={classes.wrapper}>
      <TemplateField
        currentNode={currentNode}
        onDelete={onDelete}
        onChange={onChange}
        templateIndex={templateIndex}
        setTemplates={setTemplates}
        templates={templates}
        setError={setError}
        setIsChange={setIsChange}
        setIsHideNestedItems={setIsHideNestedItems}
        isHideNestedItems={isHideNestedItems}
        renderExpandButton
      />

      {!isHideNestedItems &&
        currentNode.value.value.map((item, i) => {
          const { value } = item;
          if (Array.isArray(value.value)) {
            return (
              <div key={i} className={classes.shift}>
                <TemplateNestedField
                  currentNode={item}
                  onDelete={onDelete}
                  onChange={onChange}
                  templateIndex={templateIndex}
                  setTemplates={setTemplates}
                  templates={templates}
                  setError={setError}
                  setIsChange={setIsChange}
                />
              </div>
            );
          } else {
            return (
              <div key={i} className={classes.shift}>
                <TemplateField
                  currentNode={item}
                  onDelete={onDelete}
                  onChange={onChange}
                  templateIndex={templateIndex}
                  setTemplates={setTemplates}
                  templates={templates}
                  setError={setError}
                  setIsChange={setIsChange}
                />
              </div>
            );
          }
        })}
    </div>
  );
};

export default TemplateNestedField;
